import { CaseDisplayGroupItem, CaseDisplayGroupType } from "generated/graphql";
import { stripNull } from "helpers/coll";

export function createCaseDisplayGroupItemComparator(groupType: CaseDisplayGroupType) {
  return groupType === CaseDisplayGroupType.Card
    ? (a: CaseDisplayGroupItem, b: CaseDisplayGroupItem) => a.rank - b.rank
    : (a: CaseDisplayGroupItem, b: CaseDisplayGroupItem) => {
        const aColIndex = stripNull(a.colIndex);
        const aRowIndex = stripNull(a.rowIndex);
        const bColIndex = stripNull(b.colIndex);
        const bRowIndex = stripNull(b.rowIndex);

        if (aColIndex === undefined || aRowIndex === undefined || bColIndex === undefined || bRowIndex === undefined)
          return a.rank - b.rank;
        else {
          return aRowIndex === bRowIndex ? aColIndex - bColIndex : aRowIndex - bRowIndex;
        }
      };
}
